import { type FC } from "react";
import { Controller, type Control } from "react-hook-form";

import { useDetailsInlineSaving } from "@ds/components/details-view/hooks";
import { Dropdown } from "@ds/components/forms/inputs";
import { LabelWrapper } from "@ds/components/forms/labels";
import { useOnMouseEventPreventDefaultHandler } from "@ds/utils/handlers";

const MixingStrategyOptions = [
  { label: "Time Slice", value: "time_slice" },
  { label: "Interleaved", value: "interleaved" },
];

export const CampaignMixingStrategyControl: FC<{
  control: Control<Campaign>;
  autoFocus?: boolean;
  excludeLabel?: boolean;
  onBlur?: () => void;
}> = ({ control, autoFocus, excludeLabel, onBlur }) => {
  const onBlurHandler = useDetailsInlineSaving(onBlur);
  const onMouseDownHandler = useOnMouseEventPreventDefaultHandler();
  return (
    <Controller
      name="mixing_strategy"
      control={control as Control<Campaign>}
      render={({ field: { ref, value, onChange, onBlur: onBlurFn, ...restFields }, fieldState }) => {
        const element = (
          <Dropdown
            inputRef={ref}
            value={value}
            options={MixingStrategyOptions}
            autoFocus={autoFocus}
            onChange={({ value: strategy }) => onChange(strategy)}
            onBlur={onBlurHandler(onBlurFn)}
            onMouseDown={onMouseDownHandler}
            {...restFields}
          />
        );

        if (excludeLabel) {
          return element;
        }

        return (
          <LabelWrapper label="Mixing Strategy" className="col-8" error={fieldState.error} isRequired>
            {element}
          </LabelWrapper>
        );
      }}
    />
  );
};
